<script>
    export let error;
</script>

<div>Error: Malformed call ({error.message})</div>
